module.exports = __webpack_public_path__ + "static/media/hard_dollars_6.fcfb23c1.png";